import i18n from 'i18next';

/**
 * Mensagem de erro tratada vinda do backend (CommandResult) pra mostrar na tela.
 * Mesma regra do konq-backoffice (utils/apiError.ts):
 *  - 4xx (regra de negócio / validação): mensagem real do backend (mensagem ou 1ª notificação).
 *  - 5xx (erro técnico): não expõe detalhe técnico — usa a notificação amigável do
 *    ErrorHandlingMiddleware do backend, ou o fallback.
 *  - Sem resposta (rede / abort): mensagem do erro nativo, ou o fallback.
 *
 * Aceita os dois formatos de rejeição do app: o erro do axios (API de concurso,
 * `e.response.data`) e o payload direto (API admin, que rejeita só o `data`).
 *
 * Padrão da API: { code, mensagem, data, sucesso, notificacoes: [{ key, message }] }
 */
export function extrairMensagemErro(erro, fallback = i18n.t('erro.operacao')) {
  const response = erro?.response;
  const ehPayload = !response && erro && typeof erro === 'object' && ('mensagem' in erro || 'notificacoes' in erro);
  const data = response?.data ?? (ehPayload ? erro : null);

  if (!data || typeof data !== 'object') {
    const msg = typeof erro === 'string' ? erro : erro?.message;
    // Mensagens técnicas do axios ("Request failed with status code 404", "timeout of…") não vão pra tela
    const tecnica = /^(Network Error|Request failed with status code|timeout of|canceled)/i;
    return msg && !tecnica.test(msg) ? msg : fallback;
  }

  const status = response?.status ?? data.statusCode ?? data.code ?? 0;
  const primeiraNotificacao = Array.isArray(data.notificacoes)
    ? data.notificacoes.map((n) => (n?.message ?? n?.mensagem ?? '').trim()).find(Boolean)
    : null;

  if (status >= 500) return primeiraNotificacao || fallback;
  if (typeof data.mensagem === 'string' && data.mensagem.trim()) return data.mensagem.trim();
  return primeiraNotificacao || fallback;
}

/** Status HTTP (ou o `code` do CommandResult) de um erro, nos dois formatos. */
export function statusErro(erro) {
  if (erro?.response?.status) return erro.response.status;
  if (typeof erro?.statusCode === 'number') return erro.statusCode;
  if (typeof erro?.code === 'number') return erro.code; // axios usa code string (ERR_NETWORK...) — ignora
  return typeof erro?.status === 'number' ? erro.status : null;
}
